import { ReactElement } from "react"

import Select from "react-select"

import ModaConnect from "./ModaConnect"

import { useGetApiKeyListQuery } from "../../../services/core/user"

import { useDataModaUploadContext } from "../../../providers/DataModaUploadContext"

const ModaConfig = (): ReactElement => {
  const { keyValue, setKeyValue, setKeyLabel, setModaForm, modaForm } = useDataModaUploadContext()

  const { data, isFetching } = useGetApiKeyListQuery({
    dataProviderPlatformId: 3,
  })

  const getFormattedList = () => {
    if (!data || !Array.isArray(data)) return []

    return data.map(item => {
      return {
        value: item.value,
        label: item.name,
      }
    })
  }

  const ModaApiKeySelect = () => {
    return (
      <div>
        <div className="text-xl font-bold mb-2">Provide a MODA API key</div>
        <Select
          isSearchable
          isClearable
          isLoading={isFetching}
          placeholder="Select a MODA API key"
          className="xl:w-1/2 w-full"
          classNamePrefix="select"
          options={getFormattedList()}
          onChange={selection => {
            setKeyValue(selection?.value || null)
            setKeyLabel(selection?.label || null)
            setModaForm({
              ...modaForm,
              apiKey: selection?.value || undefined,
            })
          }}
          value={undefined}
        />
      </div>
    )
  }

  return keyValue ? <ModaConnect /> : <ModaApiKeySelect />
}

export default ModaConfig
